import type { BeatState, ColorPalette, SongSection, VisualStyle } from '../types';

export interface SceneProps {
  palette: ColorPalette;
  intensity: number;
  beat: BeatState;
  progressMs: number;
  lyric: string;
  albumArtUrl: string;
  visualStyle: VisualStyle;
  section: SongSection;
  eventStartMs: number;
  eventEndMs: number;
  params: Record<string, number | string | boolean>;
}

export function rgb([r, g, b]: [number, number, number], _alpha = 1): string {
  return `rgb(${r},${g},${b})`;
}

export function useSceneFrame(beat: BeatState, intensity: number) {
  const groove = Math.pow(Math.max(0, 1 - beat.beatPhase), 1.25) * 0.22;
  const impactAge = (beat.beatIndex % 8) + beat.beatPhase;
  const phraseAge = (beat.beatIndex % 32) + beat.beatPhase;
  const impact = impactAge <= 1.15 ? Math.pow(1 - impactAge / 1.15, 1.45) : 0;
  const phrase = phraseAge <= 1.15 ? Math.pow(1 - phraseAge / 1.15, 1.45) : 0;
  const pulse = groove + impact * 0.9 + phrase * 0.56;
  return {
    pulse: pulse * intensity,
    spin: beat.beatPhase * Math.PI * 2,
    zoom: 1 + pulse * 0.15 * intensity,
  };
}
